<mat-toolbar class="d-flex flex-row justify-content-between">
    <button
        mat-flat-button
        color="primary"
        (click)="back()">
        <mat-icon fontSet="material-symbols-outlined">arrow_back</mat-icon>
        {{ 'ECMR.common.back' | translate }}
    </button>
    <div class="fs-6">
        {{ 'ECMR.history.title' | translate }}: {{ referenceId }}
    </div>
</mat-toolbar>
@for (log of historyLogs(); track log) {
    <div
        class="d-flex flex-row p-3 gap-4 align-items-center justify-content-between data-container">
        <div class="d-flex flex-row gap-2">
            @switch (log.actionType) {
                @case (ActionType.Creation) {
                    <mat-icon
                        fontSet="material-symbols-outlined"
                        color="primary"
                        >add</mat-icon
                    >
                }
                @case (ActionType.Edit) {
                    <mat-icon
                        fontSet="material-symbols-outlined"
                        color="primary"
                        >edit</mat-icon
                    >
                }
                @case (ActionType.Share_Internal) {
                    <mat-icon
                        fontSet="material-symbols-outlined"
                        color="primary"
                        >share</mat-icon
                    >
                }
                @case (ActionType.Share_External) {
                    <mat-icon
                        fontSet="material-symbols-outlined"
                        color="primary"
                        >share</mat-icon
                    >
                }
                @case (ActionType.Share_Guest) {
                    <mat-icon
                        fontSet="material-symbols-outlined"
                        color="primary"
                        >share</mat-icon
                    >
                }
            }
            <div>|</div>
            <div>
                {{
                    'ECMR.history.actiontype.' + log.actionType.toLowerCase()
                        | translate
                }}
                @if (log.shareWith) {
                    <span class="ms-1">
                        {{ 'ECMR.history.shared_with' | translate }}: {{ log.shareWith }}
                        ({{ log.shareRole }})
                    </span>
                }
            </div>
        </div>
        <div class="d-flex flex-column">
            <div>{{ dateTimeService.transformDate(log.timestamp) }}</div>
            <div>{{ log.actionFrom }}</div>
        </div>
    </div>
}
